module.exports = __webpack_public_path__ + "static/img/banner-1.8ed5eb28.png";